import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";

import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import FormInput from "../../components/form-input/form.component";

import { SOCIAL_DATA } from "./social.data";

const useStyles = makeStyles((theme) => ({
  main: {
    width: "95%",
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.up("xs")]: {
      marginTop: 50,
    },
  },

  media: {
    height: 200,
  },
}));

const SocialPage = () => {
  const classes = useStyles();
  const [toggle, setToggle] = useState(true);

  const toggleManager = () => {
    setToggle(!toggle);
  };

  const data = SOCIAL_DATA;
  return (
    <div>
      {toggle ? (
        <FormInput toggleManager={toggleManager} />
      ) : (
        <div className={classes.main}>
          <Grid container spacing={3}>
            {data.map((item) => (
              <Grid item xs={12} md={4}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardMedia className={classes.media} image={item.image} />
                    <CardContent>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        {item.post}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </div>
      )}
    </div>
  );
};

export default SocialPage;
